import React from 'react'

const FighterSubtitle = ({ color, children }) => (
  <p className="fighter-subtitle" style={{ color, margin: 0, marginBottom: 10 }}>
    {children}
  </p>
)

export default FighterSubtitle
